;(function() {
    var

    //
    //init
    //
    init = function () {
        var $body = $("body");

        setupButtons($body);
        enterKeyTarget();
    },


    //
    // buttonValueProvider - Pull the button value from another control.
    //      Add a data-button-value-provider="jquery selector", the button value will be set to the val() of the element
    //      specified by the selector.
    //
    //      <button data-button-value-provider="#txtName">
    //      <input type="text" id="txtName" value="Jim" />
    //
    //      When the button is clicked the button value is set to "Jim"
    setupButtons = function ($container) {
        $container.on("click", "button", function () {
            $btn = $(this);

            //setup button value provider
            if ($btn.is("[data-button-value-provider]")) {
                //get the selector for the control containing the value
                var selector = $btn.attr("data-button-value-provider");

                //get the value
                var val = $(selector).val();

                //set the value for the button
                $btn.val(val);
            }
        });
    },

    //
    //enterKeyTarget - click a button when the enter key is pressed in a textbox.
    //
    //Add a data-enter-key-target="jquery selector", the button specified by the selector will be clicked.
    //
    //      <input type="text" data-enter-key-target="#btnGo" />
    //      <button id="btnGo">
    //
    //      When the enter key is pressed in the textbox, btnGo is clicked.
    //
    enterKeyTarget = function () {
        $(document).keypress(function (e) {
            // Do not apply to textareas, enter key is needed for a new line
            if (e.target.nodeName.toUpperCase() != "TEXTAREA") {
                //if enter key was pressed
                if (e.which == 13) {
                    e.preventDefault();

                    //get the element, the textbox receiving the keypress
                    var $elem = $(e.target);

                    //see if it has the attribute
                    if ($elem.is("[data-enter-key-target]")) {
                        //get the selector
                        var selector = $elem.attr("data-enter-key-target");

                        //click the selector elem
                        $(selector).click();
                    }
                }
            }
        });
    };

    

    //call init
    $(document).ready(init);

})();
